import * as echarts from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import {
  BarChart,
  CustomChart,
  GaugeChart,
  LineChart,
  PieChart,
  RadarChart,
  ScatterChart,
} from 'echarts/charts'
import {
  AriaComponent,
  DataZoomComponent,
  DatasetComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  PolarComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components'
import type { App } from 'vue'
import {
  STP_CHART_RUNTIME_KEY,
  createStpChartRuntime,
} from '@/libs/charts/runtime'
import type { CreateStpChartRuntimeOptions } from '@/libs/charts/runtime'

export type StpChartPluginOptions = CreateStpChartRuntimeOptions

function registerCharts() {
  echarts.use([
    CanvasRenderer,
    BarChart,
    GaugeChart,
    LineChart,
    PieChart,
    RadarChart,
    ScatterChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DataZoomComponent,
    GraphicComponent,
    TitleComponent,
    PolarComponent,
    CustomChart,
    DatasetComponent,
    AriaComponent,
  ])
}

export default {
  install: (app: App<Element>, options: StpChartPluginOptions = {}) => {
    registerCharts()
    app.provide(STP_CHART_RUNTIME_KEY, createStpChartRuntime(options))
  },
}
